__turbopack_context__.v({
  "main": "job-module-scss-module__5Ie_ZW__main",
});
